import React, { useState, useEffect } from 'react';

function Message({ message, type, onClose }) {
  const [show, setShow] = useState(true);

  useEffect(() => {
    if (message) {
      setShow(true);
      const timer = setTimeout(() => {
        setShow(false);
        setTimeout(() => onClose && onClose(), 300);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [message, onClose]);

  if (!message || !show) return null;

  const getTypeClass = () => {
    switch (type) {
      case 'success': return 'alert-success';
      case 'error': return 'alert-danger';
      case 'warning': return 'alert-warning';
      default: return 'alert-info';
    }
  };  

  return (
    <div className={`alert ${getTypeClass()} alert-dismissible fade ${show ? 'show' : ''}`} 
         style={{ position: 'fixed', top: '20px', right: '20px', zIndex: 9999, minWidth: '300px' }}>
      {message}
      <button type="button" className="btn-close" onClick={() => {
        setShow(false);
        setTimeout(() => onClose && onClose(), 300);
      }}></button>
    </div>
  );
}

export default Message;